import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

/*
  Button Styles
 */

export const ButtonContainer = styled.div<{ smallMarginTop?: boolean }>`
  margin-top: ${props => (props.smallMarginTop ? props.theme.space.s5 : props.theme.space.s7)} !important;
  white-space: nowrap;
`;

export const StyledButton = styled(Button)<{ isHiddenForMobile?: boolean }>`
  margin: 0 ${props => props.theme.space.s5} 0 0;
  border-radius: ${props => props.theme.radii.small};
  width: 24rem;

  ${props => props.theme.mediaQueries.mediumDown} {
    display: ${props => (props.isHiddenForMobile ? 'none' : '')};
    width: 100%;
    margin-right: ${props => props.theme.space.none};
  }
`;

/*
Pharmacy Search Styles
*/
export const PoweredByGoogleLogo = styled.img`
  width: auto;
  height: 3.3rem;
  margin-left: auto;
  margin-right: -0.3rem;
`;

export const AutoCompleteMenuItemName = styled.span`
  margin: ${props => props.theme.space.none} ${props => props.theme.space.none} ${props => props.theme.space.s1};
  display: block;
`;

export const AutoCompleteMenuItemMeta = styled.span`
  display: block;
  font-size: ${props => props.theme.fontSizes.small};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  line-height: ${props => props.theme.lineHeights.small};
`;
